module.exports = __webpack_public_path__ + "img/signin-illustration.57d3e1b7.svg";